{
  "cashier": "Хазина",
  "depositTab": "Амонат",
  "withdrawTab": "Бардошт",
  "historyTab": "Таърих",
  "secureNote": "Бехатар ва рамзгузорӣшуда",
  "selectMethod": "Усули пардохтро интихоб кунед",
  "amount": "Маблағ",
  "amountPlaceholder": "Маблағро ворид кунед",
  "quickAmounts": "Маблағҳои зуд",
  "continue": "Давом додан",
  "depositNow": "Амонат гузоред",
  "withdrawNow": "Дархости бардошт",
  "methodDisabled": "Ин усул ҳанӯз фаъол нест",
  "methodsPending": "Реквизитҳои пардохт аз ҷониби админ ҳанӯз танзим нашудаанд",
  "receiptRequired": "Боргузории квитансия лозим аст — квитансия исботи пардохт нест",
  "adminVerification": "Баланс танҳо пас аз санҷиши мустақили админ зиёд мешавад",
  "noCryptoNetworks": "Шабакаҳои крипто танзим нашудаанд",
  "noAddress": "Суроғаи амонат ҳанӯз таъин нашудааст",
  "cardToCard": "Аз корт ба корт",
  "cardToCardDesc": "Интиқол ба корти бонкӣ",
  "m10": "M10",
  "m10Desc": "Интиқоли M10",
  "terminal": "Терминал",
  "terminalDesc": "Пардохти терминалӣ",
  "crypto": "Kriptovalyuta",
  "cryptoDesc": "Депозити крипто",
  "bankCardWithdraw": "Корти бонкӣ",
  "m10Withdraw": "M10",
  "cryptoWithdraw": "Крипто",
  "minMax": "Мин {{min}} — Макс {{max}}",
  "trustInstant": "Коркарди зуд ҳангоми танзим",
  "trustSecure": "Амалиётҳои бехатар",
  "trustMethods": "Корт, M10, Терминал, Крипто",
  "historyEmpty": "Транзаксия нест",
  "historyAuth": "Барои дидани таърих вуруд кунед",
  "balanceTitle": "Баланс",
  "openCashier": "Хазина",
  "topUp": "Пур кардан",
  "bonusAccount": "Ҳисоби бонус",
  "reservedFunds": "Резерв",
  "copyId": "ID-ро нусхабардорӣ кунед",
  "loginRequired": "Барои идома вуруд кунед",
  "region": "Минтақаи пардохт",
  "instructionsSoon": "Пас аз таъини реквизит дастурҳо дар ин ҷо пайдо мешаванд",
  "uploadReceipt": "Квитансияро бор кунед",
  "uploadDisabled": "Пеш аз эҷоди дархости амонат квитансия қабул намешавад",
  "depositCreated": "Дархости амонат эҷод шуд",
  "receiptUploaded": "✅ Квитансия бор шуд. Дархости пардохт сабт шуд. Лутфан интизор шавед.",
  "withdrawReserved": "Баровард захира шуд",
  "destination": "Маълумоти қабулкунанда",
  "destinationRequired": "Маълумоти қабулкунандаро ворид кунед",
  "noCvv": "CVV ва PIN талаб ва қабул намешаванд",
  "status": "Ҳолат",
  "copy": "Нусха",
  "bankPayment": "Пардохти бонкӣ",
  "currentBalance": "Баланси ҷорӣ: {{amount}}",
  "copied": "Нусха бардошта шуд",
  "selectCoin": "Танга",
  "selectNetwork": "Шабака",
  "timeRemaining": "Вақти боқимонда",
  "depositExpired": "Муҳлати ин дархости амонат гузашт. Навро эҷод кунед.",
  "cancelDeposit": "Дархостро бекор кардан",
  "qrLabel": "QR-и суроғаи амонат",
  "copyAddress": "Суроға",
  "cardHolder": "Соҳиби корт (ихтиёрӣ)",
  "sendExactAmount": "Маблағи дақиқро фиристед. Шабака ё маблағи нодуруст ҳисоб карда намешавад.",
  "noPairsConfigured": "Ҷуфти танга/шабака ҳанӯз танзим нашудааст",
  "depositCancelled": "Дархости амонат бекор шуд",
  "usdRate": "1 USD = {{rate}} AZN",
  "minUsd": "Мин ${{usd}}",
  "saveQr": "QR-ро захира кунед",
  "networkWarning": "Танҳо дар шабакаи {{network}} фиристед. Шабакаи нодуруст метавонад боиси аз даст додани маблағ шавад.",
  "filter_all": "Ҳама",
  "filter_deposit": "Депозит",
  "filter_withdrawal": "Баровардан",
  "field_card_number": "Рақами корт",
  "field_card_holder": "Соҳиби корт",
  "field_bank_name": "Бонк",
  "field_m10_account": "Ҳисоби M10",
  "field_account_holder": "Соҳиби ҳисоб",
  "field_terminal_code": "Рамзи терминал",
  "field_address": "Суроға",
  "field_asset": "Танга",
  "field_network": "Шабака",
  "field_memo": "Memo",
  "field_phone": "Телефон",
  "field_iban": "IBAN",
  "field_name": "Ном",
  "methodSelected_card_to_card": "Пардохти корт ба корт интихоб шуд",
  "methodSelected_m10": "Пардохти M10 интихоб шуд",
  "methodSelected_terminal": "Пардохти терминал интихоб шуд",
  "methodSelected_crypto": "Криптовалюта интихоб шуд",
  "cryptoUnavailable": "Депозити криптовалюта ҳоло омода нест",
  "cryptoUnavailableHint": "Суроға ва шабакаи қабул аз ҷониби админ танзим нашудааст. Маблағ нафиристед — ҳамёни қалбакӣ нишон дода намешавад.",
  "quotePreview": "Нархнома",
  "expectedCredit": "Кредити интизории AZN",
  "estimatedCrypto": "Миқдори тахминии крипто",
  "adminRateNote": "Ин қурб аз ҷониби админ муқаррар шудааст, нархи бозор нест.",
  "enterAmountFirst": "Аввал маблағро ворид кунед, баъд танга ва шабакаро интихоб намоед.",
  "status_waiting_for_payment": "Пардохт интизор аст",
  "status_detected": "Интиқол ошкор шуд",
  "status_awaiting_confirmations": "Тасдиқҳо интизоранд",
  "status_pending_review": "Баррасӣ интизор аст",
  "status_confirmed": "Тасдиқ шуд",
  "status_expired": "Мӯҳлат гузашт",
  "status_ambiguous": "Баррасии дастӣ лозим аст",
  "status_error": "Хато / дастгирӣ намешавад",
  "status_cancelled": "Бекор шуд",
  "status_rejected": "Рад шуд",
  "status_approved": "Тасдиқ шуд",
  "expiredLateNote": "Пас аз гузаштани мӯҳлат ҳам интиқоли занҷира расида метавонад. Он худкор кредит намешавад ва баррасии пайгиришаванда мехоҳад.",
  "enlargeQr": "QR-ро калон кунед",
  "closeQr": "Пӯшед",
  "confirmationTimeNote": "Таймери 10-дақиқа равзанаи интизори дархост аст, на вақти тасдиқи блокчейн.",
  "usdEquivalent": "Эквиваленти USD: ${{usd}}",
  "quoteUnavailable": "Нархнома дастрас нест. Маблағ ва шабакаро санҷед.",
  "depositRequests": "Дархостҳои депозит",
  "networkMismatch": "Танҳо ба шабакаи нишондода фиристед.",
  "safeRecovery": "Алоқа канда шуд. Дархости охирини захирашуда барқарор мешавад.",
  "historyAll": "Ҳама",
  "historyDeposit": "Депозит",
  "historyWithdrawal": "Бозпасгирӣ",
  "historyEmptyTitle": "Таърихи амалиёт холӣ аст",
  "historyEmptyDescription": "Дар ин ҷо дархостҳои депозит ва бозпасгирии шумо нишон дода мешаванд.",
  "historyBankDeposit": "Депозити бонкӣ",
  "statusPending": "Дар интизорӣ",
  "statusReview": "Дар баррасӣ",
  "statusApproved": "Тасдиқ шуд",
  "statusPaid": "Пардохт шуд",
  "statusCompleted": "Анҷом ёфт",
  "statusRejected": "Рад шуд",
  "statusExpired": "Муҳлат гузашт",
  "statusCancelled": "Бекор шуд",
  "statusFailed": "Ноком",
  "withdrawAcceptedClean": "Дархости бозпасгирии шумо қабул ва барои санҷиш фиристода шуд.",
  "selectBankLocal": "Бонкро интихоб кунед",
  "holderFullNameLocal": "Ному насаби соҳиби корт",
  "recipientCardLocal": "Рақами корти қабулкунанда",
  "availableBalanceLocal": "Бақияи дастрас",
  "backWithdrawalLocal": "Бозгашт — усулҳои бозпасгирӣ",
  "withdrawDetailsLocal": "Маълумоти бозпасгириро ворид кунед",
  "paymentMethodsLocal": "Усулҳои пардохт",
  "paymentAmountLocal": "Маблағи пардохт",
  "transactionTypeLocal": "Навъи амалиёт",
  "walletSectionsLocal": "Қисмҳои ҳамён",
  "cryptoTransferTitle": "Депозити криптовалюта",
  "cryptoTransferAmount": "Маблағи интиқол",
  "cryptoOrderAmount": "Маблағи фармоиш",
  "cryptoTransferAddress": "Суроғаи ҳамён",
  "cryptoTransferNetwork": "Шабака",
  "cryptoShowQr": "Кушодани QR-код",
  "cryptoQrWaiting": "QR-код дастрас нест",
  "cryptoNoAddress": "Суроға мавҷуд нест. Маблағ нафиристед.",
  "cryptoWarnNetwork": "Танҳо {{asset}}-ро тавассути шабакаи {{network}} фиристед. Шабакаи нодуруст метавонад боиси гум шудани маблағ гардад.",
  "cryptoWarnAmount": "Маблағ ва ҳаққи шабакаро бодиққат тафтиш кунед. Интиқоли нокифоя метавонад қабул нашавад.",
  "cryptoMoreInfo": "Маълумоти иловагӣ",
  "cryptoMemo": "Memo / Tag",
  "prevStep": "Қадами қаблӣ",
  "depositAmount": "Маблағи амонат",
  "paymentInstruction": "Дастури пардохт",
  "paymentConfirm": "Тасдиқи пардохт",
  "depositStages": "Марҳалаҳои амонат",
  "stageAmount": "Маблағ",
  "stagePayment": "Пардохт",
  "stageReceipt": "Квитансия",
  "receiptSend": "Фиристодани квитансия",
  "rejected": "Рад шуд",
  "network": "Шабака",
  "paymentNote": "Ёддошти пардохт",
  "extraPaymentInfo": "Маълумоти иловагии пардохт",
  "invalidAmount": "Маблағи дуруст ворид кунед.",
  "tapToSelect": "Барои интихоб пахш кунед",
  "walletLabel": "Ҳамён",
  "previewBanner": "РЕЖИМИ САНҶИШ: Ҳамаи кортҳои пардохт интихоб мешаванд. Пули воқеӣ нафиристед; амонат/гирифтан иҷро намешавад.",
  "otherBank": "Бонки дигар",
  "cryptoAsset": "Криптовалюта",
  "receiveAddress": "Суроғаи қабул",
  "notAssigned": "Таъин нашудааст",
  "paymentMethod": "Усули пардохт",
  "bank": "Бонк",
  "recipient": "Гиранда",
  "cardNumber": "Рақами корт",
  "qrWhenReady": "QR танҳо ҳангоми мавҷудияти суроғаи воқеӣ",
  "qrInactive": "QR ғайрифаъол",
  "qrInactiveHint": "Пас аз таъини суроға ин ҷо нишон дода мешавад.",
  "networkAttention": "Диққат: шабакаи {{network}}",
  "networkAttentionBody": "Танҳо ба суроғаи шабакаи интихобшуда фиристед. Шабака ё маблағи нодуруст метавонад боиси талафоти маблағ шавад.",
  "minDepositFees": "Амонати ҳадди ақал ва комиссия",
  "minDepositFeesBody": "Пеш аз фиристодан минимум ва комиссияро санҷед.",
  "waitingTransfer": "Интизори интиқоли шумо",
  "waitingTransferBody": "Танҳо ба реквизитҳои тасдиқшуда бо маблағи дақиқ пардохт кунед.",
  "wrongTransfer": "Дар бораи интиқолҳои нодуруст",
  "wrongTransferBody": "Пардохт ба бонк/корт ё маблағи дигар метавонад ҳисоб нашавад.",
  "previewNoAddress": "САНҶИШ · СУРОҒА НЕСТ · ПУЛ НАФИРИСТЕД",
  "addReceiptTitle": "Квитансияи пардохтро илова кунед",
  "addReceiptBody": "Камера/галерея/файл. Дар санҷиш ба сервер фиристода намешавад.",
  "cameraCapture": "Бо камера гирифтан",
  "sampleTimer": "Таймери намуна — дархости воқеӣ нест",
  "transferDetails": "Маълумоти интиқол",
  "paymentDetailsStep": "Маълумоти пардохт",
  "paymentConfirmStep": "Тасдиқи пардохт",
  "iPaidReceipt": "Ман пардохт кардам · Экрани квитансия",
  "fromGallery": "Аз галерея интихоб",
  "chooseFile": "Файли интихоб",
  "cameraFileSelected": "Файли камера интихоб шуд: {{name}}. Дар санҷиш ба сервер бор намешавад.",
  "imageSelected": "Акс интихоб шуд: {{name}}. Дар санҷиш ба сервер бор намешавад.",
  "fileSelected": "Файл интихоб шуд: {{name}}. Дар санҷиш ба сервер бор намешавад.",
  "previewTest": "Санҷиш",
  "fileNotUploaded": "Файл ба сервер бор намешавад",
  "bankSelect": "Интихоби бонк",
  "depositBonusSample": "Бонуси амонат · намуна",
  "checkFinalAmount": "Маблағи ниҳоиро дар фармоиши сохташуда санҷед.",
  "orderNumber": "Рақами фармоиш:",
  "amountDue": "Маблағи пардохтшаванда:",
  "requestProcessing": "Дархост коркард мешавад",
  "paymentCreated": "Дархости пардохт бомуваффақият сохта шуд!",
  "completeTransferHint": "Интиқолро бо маълумоти пардохти зер анҷом диҳед.",
  "exactAmountWarn": "Диққат! Танҳо маблағи нишондодаро бо маълумоти дуруст фиристед.",
  "uploadReceiptAfter": "Пас аз интиқол квитансияро бор кунед.",
  "paymentInfo": "Маълумоти пардохт",
  "cardHolderName": "Номи соҳиби корт",
  "receiverName": "Номи қабулкунанда",
  "accountNumber": "Рақами ҳисоб",
  "previewDepositSelected": "САНҶИШ: {{method}} — {{amount}} AZN интихоб шуд. Амонати воқеӣ нест; пул нафиристед.",
  "previewWithdrawChecked": "САНҶИШ: гирифтани {{amount}} AZN барои {{method}} санҷида шуд. Дархости воқеӣ нест.",
  "checkingFileSelection": "Интихоби файлро месанҷед",
  "bonusSampleLine": "5%: {{bonus}} · ҷамъ: {{total}}",
  "phoneNumber": "Рақами телефон",
  "addressLabel": "суроға",
  "uploadReceiptReminder": "Пас аз пардохт квитансияро бор карданро фаромӯш накунед.",
  "previewWithdrawBanner": "САНҶИШ: Гирифтани воқеӣ фиристода намешавад ва тавозун тағйир намеёбад.",
  "cardExpiry": "Муҳлати корт (Моҳ/Сол)",
  "checkRequest": "Санҷидани дархост",
  "bonusNotOnReal": "Ба тавозуни воқеӣ ҳисоб карда намешавад.",
  "realBalance": "Баланси асосӣ",
  "gameCurrencies": "Асъорҳои бозӣ",
  "walletCta": "Ҳамён",
  "closeGameFirst": "Дар бозии фаол шарти кушода ҳаст. Аввал бозиро бандед, баъд асъорро иваз кунед.",
  "regionLabel": "Минтақаи пардохт",
  "regionCryptoOnly": "Дар ин минтақа танҳо пардохтҳои крипто дастрасанд",
  "tonConnectTitle": "Депозит тавассути TON Connect",
  "tonConnectWallet": "Ҳамёни TON-ро пайваст кунед",
  "tonPayConfirm": "Пардохтро дар ҳамён тасдиқ кунед",
  "tonDisconnectWallet": "Ҳамёнро ҷудо кунед",
  "tonWalletStatus": "Ҳолати ҳамён",
  "tonWalletNotConnected": "Пайваст нашудааст",
  "tonWalletConnected": "Пайваст · {{address}}",
  "tonWalletConnectedHint": "Ҳамёни TON-и шумо бомуваффақият пайваст шуд.",
  "tonWalletDisconnected": "Ҳамён ҷудо шуд.",
  "tonWalletConnectFailed": "Пайваст кардани ҳамён ноком шуд.",
  "tonConnectWalletFirst": "Аввал ҳамёни TON-ро пайваст кунед.",
  "tonConfirmInWallet": "Пардохтро дар ҳамёни худ тасдиқ кунед.",
  "tonPendingAdminReview": "Дархости депозит эҷод шуд. Пардохт интизори баррасии админ аст.",
  "tonDepositCreated": "Дархости депозити TON эҷод шуд. Пардохтро бо ҳамён анҷом диҳед.",
  "tonPaymentCancelled": "Пардохт бекор шуд ё анҷом наёфт.",
  "tonPaymentMissing": "Маълумоти пардохт нест. Бори дигар кӯшиш кунед.",
  "tonPaymentProofMissing": "Ҳамён далели пардохтро барнагардонд. Агар пардохт нашуда бошад, бори дигар кӯшиш кунед.",
  "tonWarnNativeOnly": "Танҳо native TON фиристед. Токен ё шабакаи дигар метавонад боиси талафи маблағ шавад.",
  "tonWarnAdminReview": "Тасдиқи ҳамён зиёдшавии баланс нест. Баланс пас аз баррасии админ зиёд мешавад.",
  "gameCurrency": "Асъори бозӣ"
}
